import { useIntl } from "react-intl";
import { useLoading } from "../../LoadingContext";
import { Modal, Box, Typography, Grid, Button } from "@mui/material";
import PageHeader from "../../ui/PageHeader";
import { useRef } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

const ShowExistingDestinationsModal = (props) => {
  const { data } = props;

  const modalStyle = {
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "white",
    boxShadow: 24,
    width: 700,
    overflow: "auto",
    p: 4,
    borderRadius: "5px",
  };

  const intl = useIntl();

  const handleClose = (action) => {
    props.handleCloseModal(action);
  };

  return (
    <Modal open={props.openModal} onClose={handleClose}>
      <Box sx={modalStyle}>
        <PageHeader
          title={intl.formatMessage({
            id: "NdCDestinationTriang.Discarded",
          })}
        />
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item lg={12}>
            <TableContainer>
              <Table sx={{ minWidth: 650 }} size="small">
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                      }}
                    >
                      {intl.formatMessage({
                        id: "NdCDestinationTriang.BrandCode",
                      })}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                      }}
                    >
                      {intl.formatMessage({
                        id: "NdCDestinationTriang.Code",
                      })}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                      }}
                    >
                      {intl.formatMessage({
                        id: "NdCDestinationTriang.Description",
                      })}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.map((row) => (
                    <TableRow key={row.code}>
                      <TableCell>{row.brandCode}</TableCell>
                      <TableCell>{row.code}</TableCell>
                      <TableCell>{row.description}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
        <Box sx={{ background: "#bcb7b7", color: "white", mt: 2 }}>
          <Grid container>
            <div style={{ margin: "auto" }}></div>
            <Grid item xs="auto" textAlign="center">
              <Button sx={{ color: "white" }} onClick={handleClose}>
                [{intl.formatMessage({ id: "General.Ok" })}]
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Modal>
  );
};

export default ShowExistingDestinationsModal;
